import { FiToggleLeft } from "react-icons/fi";
import { FaToggleOn } from "react-icons/fa";
import Loader from "../shared/Loader";
import FloatUp from "../shared/FloatUp";
import EventCard from "../shared/EventCard";
import { Link } from "react-router-dom";

import AppContext from "../../context/Context";
import { getEvents } from "../../context/Actions";
import { useState, useEffect, useContext } from "react";

export default function Events({ upcoming, past }) {
  const [isUpcoming, setIsUpcoming] = useState(true);
  const { isLoading, events, dispatch } = useContext(AppContext);

  useEffect(() => {
    dispatch({ type: "SET_LOADING" });
    const getEventsList = async () => {
      const fetchedEvents = await getEvents();
      dispatch({ type: "GET_EVENTS", payload: fetchedEvents });
    };
    getEventsList();
  }, [dispatch]);

  const handleToggle = () => {
    setIsUpcoming(!isUpcoming);
  };

  if (isLoading) return <Loader />;
  return (
    <section className="section">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h1 className="title">
              {isUpcoming ? "Upcoming Events" : "Past Events"}
            </h1>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <button onClick={handleToggle} className="button is-white">
              <span className="mx-2"> Toggle events </span>
              {isUpcoming ? (
                <span className="icon">
                  <FiToggleLeft size="30" />
                </span>
              ) : (
                <span className="icon" style={{ color: "lightGreen" }}>
                  <FaToggleOn size="30" />
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="container my-6">
        <FloatUp>
          <div className="is-flex is-flex-wrap-wrap">
            {events
              .filter((event) => {
                if (isUpcoming) return event.status === "upcoming";
                else return event.status === "completed";
              })
              .map((event) => {
                return (
                  <div key={event._id}>
                    <Link to={`/events/${event._id}`}>
                      <EventCard
                        title={event.title}
                        description={event.description}
                        imageUrl={event.imgUrl}
                      />
                    </Link>
                  </div>
                );
              })}
          </div>
        </FloatUp>
      </div>
    </section>
  );
}
